/**
 * O símbolo da Heavy Trade (o "H" no círculo amarelo), em PNG no tamanho
 * exato, com a versão 2x para telas de alta densidade.
 *
 * PNG, E NÃO O SVG, de propósito. Em 28 px os vãos entre as barras do
 * "H" medem menos de um pixel: o SVG os borra e o "H" gruda nas barras
 * de fora. Os PNGs de public/marca/ foram desenhados para cada tamanho,
 * com as barras alinhadas ao pixel. Por isso o tamanho é um dos que
 * existem lá, e não um número qualquer.
 */
export type TamanhoMarca = 16 | 20 | 24 | 28 | 32 | 48 | 64;   // cada um tem o 2x em public/marca

const url = (px: number) => `/marca/circulo-amarelo/circulo-amarelo-${px}.png`;

export function MarcaIcone({ tamanho, className }: {
  tamanho: TamanhoMarca;
  className?: string;
}) {
  return (
    <img className={className} src={url(tamanho)}
         srcSet={`${url(tamanho)} 1x, ${url(tamanho * 2)} 2x`}
         width={tamanho} height={tamanho} alt="" aria-hidden />
  );
}
